import {Action, createReducer, on} from '@ngrx/store';
import {IAdnetState} from "../../interfaces";
import {initialAdnetState} from "../state/adnet.state";
import {
    actionAdnetAddPackage,
    actionAdnetAddPackageContent,
    actionAdnetAddPackagePair,
    actionAdnetAddPackageTarget,
    actionAdnetAddRateTable,
    actionAdnetAddTarget,
    actionAdnetAddTargetsWeb,
    actionAdnetReceivedAdnet,
    actionAdnetReceiveReport,
    actionAdnetRemoveAdnetTarget,
    actionAdnetRemovePackage,
    actionAdnetRemovePackageContent,
    actionAdnetRemoveRateTable,
    actionAdnetRemoveTargetsWeb,
    actionAdnetRenameRateTable,
    actionAdnetRequest,
    actionAdnetTargetSearch,
    actionAdnetUpdateAdnetPackage,
    actionAdnetUpdateCustomer,
    actionAdnetUpdatePackageContentProp,
    actionAdnetUpdatePairIncoming,
    actionAdnetUpdatePairOutgoing,
    actionAdnetUpdateRateTable,
    actionAdnetUpdateTargetsTable
} from "../actions/adnet.actions";
import {List} from "immutable";
import {StoreModel} from "../../models/StoreModel";
import {Lib} from "../../../libs/Lib";
import {AdnetCustomerModel} from "../../containers/adnet/models/AdnetCustomerModel";
import {AdnetRateModel} from "../../containers/adnet/models/AdnetRateModel";
import {AdnetTargetModel} from "../../containers/adnet/models/AdnetTargetModel";
import {AdnetPackageModel} from "../../containers/adnet/models/AdnetPackageModel";
import {AdnetPairModel} from "../../containers/adnet/models/AdnetPairModel";

const getIndex = (list, id: string) => {
    const res = list.findIndex((i: StoreModel) => i['getId']() === id);
    return Lib.CheckFoundIndex(res, 'adnet: Immutable findIndex did not find a match');
};

const featureReducer = createReducer(
    initialAdnetState,
    on(actionAdnetRequest, (state, {type}) => {
        return state;
    }),
    on(actionAdnetReceivedAdnet, (state, {type, adnetData}) => {
        state.packages = adnetData.packages ? adnetData.packages : List([]);
        state.payments = adnetData.payments ? adnetData.payments : List([]);
        state.customers = adnetData.customers ? adnetData.customers : List([]);
        state.rates = adnetData.rates ? adnetData.rates : List([]);
        state.targets = adnetData.targets ? adnetData.targets : List([]);
        state.reports = adnetData.reports ? adnetData.reports : List([]);
        state.targets_search = adnetData.targets_search ? adnetData.targets_search : List([]);
        state.transfers = adnetData.transfers ? adnetData.transfers : List([]);
        state.pairs = adnetData.pairs ? adnetData.pairs : List([]);
        return state;
    }),
    on(actionAdnetAddRateTable, (state, {type, payload}) => {
        state.rates = state.rates.push(payload);
        return state;
    }),
    on(actionAdnetRemoveRateTable, (state, {type, payload}) => {
        state.rates = state.rates.filter((model: AdnetRateModel) => model.getId() !== payload) as List<AdnetRateModel>;
        return state;
    }),
    on(actionAdnetUpdateRateTable, (state, {type, payload}) => {
        state.rates = state.rates.update(getIndex(state.rates, payload['rateId']), (rate: AdnetRateModel) => {
            return rate.setField('rateMap', payload['rateTable']);
        });
        state.rates = state.rates.update(getIndex(state.rates, payload['rateId']), (rate: AdnetRateModel) => {
            rate = rate.setField('hourRate0', payload['adHourlyRate']["0"]);
            rate = rate.setField('hourRate1', payload['adHourlyRate']["1"]);
            rate = rate.setField('hourRate2', payload['adHourlyRate']["2"]);
            rate = rate.setField('hourRate3', payload['adHourlyRate']["3"]);
            return rate;
        });
        return state;
    }),
    on(actionAdnetRenameRateTable, (state, {type, payload}) => {
        state.rates = state.rates.update(getIndex(state.rates, payload.rateId), (rate: AdnetRateModel) => {
            return rate.setField('label', payload.newLabel);
        });
        return state;
    }),
    on(actionAdnetUpdateCustomer, (state, {type, payload}) => {
            state.customers = state.customers.update(getIndex(state.customers, payload.Key), (customer: AdnetCustomerModel) => {
                return customer.setData<AdnetCustomerModel>(AdnetCustomerModel, payload);
            });
            return state;
        }
    ),
    on(actionAdnetUpdateTargetsTable, (state, {type, payload}) => {
        state.targets = state.targets.update(getIndex(state.targets, payload.Key), (target: AdnetTargetModel) => {
            return target.setData<AdnetTargetModel>(AdnetTargetModel, payload);
        });
        return state;
    }),
    on(actionAdnetAddTargetsWeb, (state, {type, payload}) => {
        state.targets = state.targets.push(payload);
        return state;
    }),
    on(actionAdnetRemoveTargetsWeb, (state, {type, payload}) => {
        state.targets = state.targets.filter((model: AdnetTargetModel) => model.getId() !== payload) as List<AdnetTargetModel>;
        return state;
    }),


    on(actionAdnetReceiveReport, (state, {type, payload}) => {
        state.reports = payload;
        return state;
    }),
    on(actionAdnetAddPackage, (state, {type, payload}) => {
        state.packages = state.packages.push(payload);
        return state;
    }),
    on(actionAdnetUpdatePackageContentProp, (state, {type, payload}) => {
        let adnetPackageModel;
        state.packages = state.packages.update(getIndex(state.packages, payload.packageId), (i_package: AdnetPackageModel) => {
            let contents = i_package.getContents();
            for (let index in contents) {
                if (contents[index].Key == payload.data.Key) {
                    let packageData = i_package.getData().toJS();
                    packageData.Value.contents[index] = payload.data;
                    return i_package.setData<AdnetPackageModel>(AdnetPackageModel, packageData);
                }
            }
            return adnetPackageModel;
        });
        return state;
    }),
    on(actionAdnetRemovePackageContent, (state, {type, payload}) => {
        let adnetPackageModel;
        state.packages = state.packages.update(getIndex(state.packages, payload.payloadToSave.Key), (i_package: AdnetPackageModel) => {
            let contents = i_package.getContents();
            for (let i = 0; i < contents.length; i++) {
                let content = contents[i];
                if (content.Value.deleted)
                    continue;
                if (content.Key != Number(payload.payloadToSave.Value.packageContents.delete[0]))
                    continue;
                contents.splice(i, 1);
                let packageData = i_package.getData().toJS();
                packageData.Value.contents = contents;
                return i_package.setData<AdnetPackageModel>(AdnetPackageModel, packageData);
            }
            return adnetPackageModel;
        });
        return state;
    }),
    on(actionAdnetAddTarget, (state, {type, payload}) => {
        // look for existing target, if found nothing to do
        let found = state.targets.filter((i_targetModel: AdnetTargetModel) => {
            return i_targetModel.getId() == payload;
        });
        if (found.size > 0) return state;
        const targetModel: AdnetTargetModel = state.targets_search.filter((i_targetModel: AdnetTargetModel) => {
            return i_targetModel.getId() == payload;
        }).first() as AdnetTargetModel;
        state.targets = state.targets.push(targetModel);
        return state;
    }),
    on(actionAdnetAddPackageTarget, (state, {type, payload}) => {
        state.packages = state.packages.update(getIndex(state.packages, payload.packageId), (i_package: AdnetPackageModel) => {
            const packageData = i_package.getData().toJS();
            packageData.Value.targets.push(payload.data);
            return i_package.setData<AdnetPackageModel>(AdnetPackageModel, packageData);
        });
        return state;
    }),
    on(actionAdnetAddPackagePair, (state, {type, payload}) => {
        state.pairs = state.pairs.push(payload);
        return state;
    }),
    on(actionAdnetRemoveAdnetTarget, (state, {type, payload}) => {
        // let packages: List<AdnetPackageModel> = state.getIn(['packages']);
        let adnetPackageModel;
        state.packages = state.packages.update(getIndex(state.packages, payload.packageId), (i_package: AdnetPackageModel) => {
            let targets = i_package.getTargets();
            for (let i = 0; i < targets.length; i++) {
                let target = targets[i];
                if (target['Value'].deleted)
                    continue;
                if (target['Key'] != payload.targetId)
                    continue;
                targets.splice(i, 1);
                const packageData = i_package.getData().toJS();
                packageData.Value.targets = targets;
                return i_package.setData<AdnetPackageModel>(AdnetPackageModel, packageData);
            }
            return adnetPackageModel;
        });
        return state;
    }),
    on(actionAdnetUpdateAdnetPackage, (state, {type, payload}) => {
        // let packages: List<AdnetPackageModel> = state.getIn(['packages']);
        state.packages = state.packages.update(getIndex(state.packages, payload.Key), (i_package: AdnetPackageModel) => {
            return i_package.setData<AdnetPackageModel>(AdnetPackageModel, payload);
        });
        return state;
    }),
    on(actionAdnetUpdatePairOutgoing, (state, {type, payload}) => {
        state.pairs = state.pairs.update(getIndex(state.pairs, payload.toPairs.update[0].Key), (pair: AdnetPairModel) => {
            return pair.setField('friend', payload.toPairs.update[0].Value.friend);
        });
        return state;
    }),
    on(actionAdnetUpdatePairIncoming, (state, {type, payload}) => {
        state.pairs = state.pairs.update(getIndex(state.pairs, payload.fromPairs.update[0].Key), (pair: AdnetPairModel) => {
            return pair.setField('friend', payload.fromPairs.update[0].Value.friend);
        });
        return state;
    }),
    on(actionAdnetAddPackageContent, (state, {type, payload}) => {
        state.packages = state.packages.update(getIndex(state.packages, payload.adnetPackageId), (i_package: AdnetPackageModel) => {
            const packageData = i_package.getData().toJS();
            packageData.Value.contents.push(payload.data);
            return i_package.setData<AdnetPackageModel>(AdnetPackageModel, packageData);
        });
        return state;
    }),

    on(actionAdnetRemovePackage, (state, {type, payload}) => {
        state.packages = state.packages.filter((model: AdnetPackageModel) => model.getId() !== payload) as List<AdnetPackageModel>;
        return state;
    }),

    on(actionAdnetTargetSearch, (state, {type, payload}) => {
        state.targets_search = payload.adnetTargets;

        let rates: List<AdnetRateModel> = state.rates;
        payload.adnetRates.forEach((i_rate: AdnetRateModel) => {
            const found = rates.filter((ii_rate: AdnetRateModel) => ii_rate.getId() == i_rate.getId());
            if (found.size === 0) rates = rates.push(i_rate);
        });
        state.rates = rates;

        let customers: List<AdnetCustomerModel> = state.customers;
        payload.adnetCustomers.forEach((i_customer: AdnetCustomerModel) => {
            const found = customers.filter((ii_customer: AdnetCustomerModel) => ii_customer.getId() == i_customer.getId());
            if (found.size === 0) customers = customers.push(i_customer);
        });
        state.customers = customers;

        return state;
    })
);

export function adnetReducers(state: IAdnetState | undefined, action: Action): IAdnetState {
    return featureReducer(state, action);
}
